<puro-header
  [navItems]="navItems()"
  [languageLabel]="languageLabel()"
  [showLanguageToggle]="true"
  [showNotificationIcon]="false"
  [showUserAvatar]="true"
  [isLoggedIn]="true"
  [hasProjectedLogo]="true"
  (languageToggle)="languageToggle.emit()"
>
  <img
    headerLogo
    src="assets/Purolator-logo-colour.svg"
    alt="Purolator"
    class="puro-header__logo-img"
  />
</puro-header>

@if (userMenuOpen()) {
  <nav
    #userMenuNav
    class="app-shell__user-dropdown"
    [attr.aria-label]="'layout.userMenu.aria' | translate"
  >
    <button
      type="button"
      class="app-shell__user-dropdown-item app-shell__user-dropdown-item--logout"
      (click)="logOut.emit()"
    >
      <img
        class="app-shell__user-dropdown-icon"
        src="assets/icons/box-arrow-right-logout.svg"
        alt=""
        aria-hidden="true"
        width="16"
        height="16"
      />
      <span class="app-shell__user-dropdown-label">{{ 'layout.userMenu.logOut' | translate }}</span>
    </button>
  </nav>
}
